var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhychooseFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467.117 88.631-208-88c-1.992-.842-4.241-.842-6.234 0l-208 88c-2.96 1.253-4.883 4.155-4.883 7.369v126.377c0 131.64 85.328 249.787 213.647 289.27 1.534.471 3.169.472 4.705 0 125.819-38.714 213.648-155.014 213.648-289.271v-126.376c0-3.214-1.923-6.116-4.883-7.369zm-11.117 133.745c0 125.813-80.262 235.308-200 273.242-119.738-37.934-200-147.428-200-273.242v-121.075l200-84.615 200 84.615z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.03 314.343c9.381 9.38 24.561 9.379 33.94 0l104.687-104.687c9.735-9.736 9.735-25.578 0-35.314-9.736-9.734-25.578-9.734-35.314 0l-86.343 86.344-38.343-38.344c-9.736-9.734-25.577-9.734-35.313 0-9.759 9.758-9.76 25.556 0 35.314zm-45.374-80.686c3.497-3.497 9.189-3.498 12.687 0l44 44c3.124 3.123 8.189 3.123 11.313 0l92.001-92c1.693-1.694 3.946-2.627 6.343-2.627 7.972 0 11.957 9.7 6.343 15.313l-104.687 104.686c-3.119 3.119-8.194 3.119-11.313 0l-56.687-56.687c-3.505-3.506-3.506-9.179 0-12.685z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.717 48.705-160 72c-2.871 1.291-4.717 4.146-4.717 7.295v102.483c0 104.788 66.452 198.451 165.357 233.067 1.818.637 3.811.597 5.614-.123l9.805-3.923c93.799-37.519 155.224-128.25 155.224-229.268v-102.236c0-3.148-1.847-6.004-4.717-7.295l-160-72c-2.089-.94-4.48-.94-6.566 0zm155.283 84.467v97.063c0 94.978-56.98 179.14-145.166 214.413l-6.995 2.799c-90.947-33.149-151.839-119.958-151.839-216.964v-97.311l152-68.4z",
    fill: "#000000",
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhychooseFour);
export default __webpack_public_path__ + "static/media/whychoose_four.634293ed0360e2e5ebd1e8cdd8432610.svg";
export { ForwardRef as ReactComponent };